<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptertitle">Table of Contents</h1><p class="left"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="left"><a href="#/toc">Table of Contents</a></p>
<p class="left"><a href="#/front01">Copyright</a></p>
<p class="left"><a href="#/front02">Foreword</a></p>
<p class="left"><a href="#/front03">Introduction</a></p>
<p class="left"><a href="#/c01">CHARLES BAXTER
  Charity</a></p>
<p class="left"><a href="#/c02">ANN BEATTIE
  The Indian Uprising</a></p>
<p class="left"><span href="#/c03" title="Link target outside of Sample">T. C. BOYLE
  The Night of the Satellite</span></p>
<p class="left"><span href="#/c04" title="Link target outside of Sample">PETER CAMERON
  After the Flood</span></p>
<p class="left"><span href="#/c05" title="Link target outside of Sample">NICOLE CULLEN
  Long Tom Lookout</span></p>
<p class="left"><span href="#/c06" title="Link target outside of Sample">CRAIG DAVIDSON
  Medium Tough</span></p>
<p class="left"><span href="#/c07" title="Link target outside of Sample">JOSHUA FERRIS
  The Breeze</span></p>
<p class="left"><span href="#/c08" title="Link target outside of Sample">NELL FREUDENBERGER
  Hover</span></p>
<p class="left"><span href="#/c09" title="Link target outside of Sample">DAVID GATES
  A Hand Reached Down to Guide Me</span></p>
<p class="left"><span href="#/c10" title="Link target outside of Sample">LAUREN GROFF
  At the Round Earth’s Imagined Corners</span></p>
<p class="left"><span href="#/c11" title="Link target outside of Sample">RUTH PRAWER JHABVALA
  The Judge’s Will</span></p>
<p class="left"><span href="#/c12" title="Link target outside of Sample">O. A. LINDSEY
  Evie M.</span></p>
<p class="left"><span href="#/c13" title="Link target outside of Sample">WILL MACKIN
  Kattekoppen</span></p>
<p class="left"><span href="#/c14" title="Link target outside of Sample">BRENDAN MATHEWS
  This Is Not a Love Song</span></p>
<p class="left"><span href="#/c15" title="Link target outside of Sample">MOLLY McNETT
  La Pulchra Nota</span></p>
<p class="left"><span href="#/c16" title="Link target outside of Sample">BENJAMIN NUGENT
  God</span></p>
<p class="left"><span href="#/c17" title="Link target outside of Sample">JOYCE CAROL OATES
  Mastiff</span></p>
<p class="left"><span href="#/c18" title="Link target outside of Sample">STEPHEN O’CONNOR
  Next to Nothing</span></p>
<p class="left"><span href="#/c19" title="Link target outside of Sample">KAREN RUSSELL
  Madame Bovary’s Greyhound</span></p>
<p class="left"><span href="#/c20" title="Link target outside of Sample">LAURA VAN DEN BERG
  Antarctica</span></p>
<p class="left"><span href="#/back01" title="Link target outside of Sample">Contributors’ Notes</span></p>
<p class="left"><span href="#/back02" title="Link target outside of Sample">Other Distinguished Stories of 2013</span></p>
<p class="left"><span href="#/back03" title="Link target outside of Sample">Editorial Addresses of American and Canadian Magazines Publishing Short Stories</span></p>
<p class="left"><span href="#/back04" title="Link target outside of Sample">Read More from The Best American Series®</span></p>
<p class="left"><span href="#/back05" title="Link target outside of Sample">About the Editors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?816c95f0